import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryWorkTypeId,
    MyTimesheetEntryWorkTypeIsPieceRate,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Components
// @ts-ignore
import WorkTypeIsPieceRateGate from 'scenes/Time/components/WorkTypeIsPieceRateGate';

// Global Selectors
import {
    makeSelectMyTimesheetEntryWorkTypeId,
    makeSelectMyTimesheetWorkTypeIsPieceRate
} from 'services/myTimesheetEntries/selectors';
import { selectCurrentMyTimesheetIsEditable } from 'services/myTimesheets/selectors';

interface ConnectedProps {
    currentMyTimesheetIsEditable?: boolean | null;
    workTypeId?: MyTimesheetEntryWorkTypeId;
    workTypeIsPieceRate?: MyTimesheetEntryWorkTypeIsPieceRate;
}

interface OwnProps extends MyTimesheetEntriesProps {
    children: React.ReactNode;
}

type Props = OwnProps & ConnectedProps;

/**
 * A component to wrap around content only visible piece rate work type
 */
export class MyTimesheetEntryWorkTypeIsPieceRateGate extends React.PureComponent<
    Props
> {
    render(): React.ReactNode | null {
        const {
            children,
            workTypeIsPieceRate,
            currentMyTimesheetIsEditable,
            workTypeId
        } = this.props;

        // If editable use the workType that exists in state
        if (currentMyTimesheetIsEditable) {
            return (
                <WorkTypeIsPieceRateGate workTypeId={workTypeId}>
                    {children}
                </WorkTypeIsPieceRateGate>
            );
        }

        if (!workTypeIsPieceRate) {
            return null;
        }

        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    currentMyTimesheetIsEditable: selectCurrentMyTimesheetIsEditable,
    workTypeId: makeSelectMyTimesheetEntryWorkTypeId(),
    workTypeIsPieceRate: makeSelectMyTimesheetWorkTypeIsPieceRate()
});

export default connect(mapStateToProps)(
    MyTimesheetEntryWorkTypeIsPieceRateGate
);
